var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataDictionary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A194D6;}\n\t.st1{fill:#C6BDE8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-282.6,408.3h-1.5v-21.6c0-2.7,2.2-5,5-5h16.6c0.4,0,0.8,0.3,0.8,0.8v22.6h-1.5v-21.9h-16 c-1.9,0-3.5,1.6-3.5,3.5v21.6H-282.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-262.6,405.1h-17.6c-1.8,0-3.2,1.4-3.2,3.2l0,0c0,1.8,1.4,3.2,3.2,3.2h17.6 C-262.6,411.5-262.6,405.1-262.6,405.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-262.6,412.2h-17.6c-2.2,0-3.9-1.8-3.9-3.9c0-2.1,1.8-3.9,3.9-3.9h17.6c0.4,0,0.8,0.3,0.8,0.8v6.4 C-261.9,411.9-262.2,412.2-262.6,412.2z M-280.2,405.9c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4h16.8v-4.9h-16.8V405.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -277.2,
    y: 387.1,
    className: "st0",
    width: 8.7,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -277.2,
    y: 391.9,
    className: "st0",
    width: 8.7,
    height: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataDictionary);
export default __webpack_public_path__ + "static/media/data_dictionary.bc7ccdfa67b1789fd82efe8414178bf2.svg";
export { ForwardRef as ReactComponent };